module.exports = __webpack_public_path__ + "img/vaulanteer.4139403f.png";